import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import appUrls from '../config/urls';

@Injectable({
  providedIn: 'root'
})
export class LineStatisticsService {
  url = appUrls.lineDetails;
  constructor(private http: HttpClient) { }


  getLineStatisticsById(line: any) {
    return this.http.post(this.url.getLineStatistics , line);
  }

}
